import { render, staticRenderFns } from "./YabanciKimlikNumarasi.vue?vue&type=template&id=a69fe366"
import script from "./YabanciKimlikNumarasi.vue?vue&type=script&lang=ts"
export * from "./YabanciKimlikNumarasi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports